<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="4">
					<select-combo
						:label="getMessage_('QWCC001137')"
						paramKey="powLnCd"
						:options="powLnList"
						:propData="popupSearchParams.powLnCd"
						@commChange="commChange"
						:showAll="false"
					></select-combo>
				</el-col>
				<el-col :span="4">
					<div class="sf-input-group-wrapper">
						<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC000070') }}</span>
						<div class="search-option-wrapper__normal">
							<el-date-picker
								format="yyyy-MM-dd"
								value-format="yyyyMMdd"
								:value="popupSearchParams.insnDd"
								@input="val => setSearchParam(val, 'insnDd')"
							/>
						</div>
					</div>
				</el-col>
				<el-col :span="4">
					<search-input
						:label="getMessage_('QWCC001379')"
						paramKey="ipnNos"
						@commInput="({ key, value }) => setSearchParam(value, key)"
						:filterReg="/[^-\.0-9]/g"
						:clearable="true"
						:propData="popupSearchParams.ipnNos"
					>
					</search-input>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/ptin/PowTourStts/store/helpers';
import SelectCombo from '@qms/Components/SelectCombo';
import SearchInput from '@qms/Components/SearchInput';
export default {
	props: { scrId: { type: String, default: '' } },
	data() {
		return { searchDateRange: [] };
	},
	components: { SelectCombo, SearchInput },
	async created() {
		await this.getCommCodes_({ key: 'powLnList', codeType: 'OCCU_PL' });
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		setSearchParam(value, key) {
			this.setPopupSearchParams_({ key, value });
		},
		commChange(param) {
			this.setPopupSearchParams_(param);
		},
		async searchList() {
			this.$sf_toggleLoading(true);
			let response;
			try {
				if (this.isSaved) {
					//수정된 내용이 있을 경우
					this.$sf_showMessage({
						type: 'confirm',
						icon: 'confirm',
						message: this.getMessage_('QWCC001511'),
						buttons: [
							{
								title: 'Ok',
								clickFn: async () => {
									this.setPopupInit_();
									response = await this.getSearchOne_();
									this.getResponse(response);
								}
							}
						]
					});
				} else {
					this.setPopupInit_();
					response = await this.getSearchOne_();
					this.getResponse(response);
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			} finally {
				this.setState_({ key: 'isSaved', value: false });
				this.$sf_toggleLoading(false);
			}
		},
		// 서버에서 결과값 받으면 그 이후 공통적으로 로직 처리
		getResponse(response) {
			if (response) {
				const { code, messageCd } = response;
				this.$sf_toast({
					type: code === 0 ? 'ok' : 'error',
					message: this.getMessage_(messageCd)
				});
				code == 0 && this.$emit('loadImgAll'); // code:0 정상 -> img 재로드
				code == 2 && this.$emit('initComp'); // code:2 결과 없음 -> 모든 컴포넌트 초기화
			} else {
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001151') });
			}
		}
	},
	computed: { ...rootComputed, ...serviceComputed }
};
</script>

<style></style>
